// Only works with either a 6-digit (e.g. #d9d9d9) or 3-digit (e.g. #cf4) hex code
// Pass in a positive number to generate lighter shade (e.g. 10, 15, 20)
// Pass in a negative number to generate darker shade (e.g. -20, -30, -50)

const normalizeHex = (hex: string) => {
  if (hex.length > 3) {
    return hex;
  }

  const red = `${hex[0]}${hex[0]}`;
  const green = `${hex[1]}${hex[1]}`;
  const blue = `${hex[2]}${hex[2]}`;

  return `${red}${green}${blue}`;
};

const generateHexShade = (hexCode: string, percent: number) => {
  if (!hexCode) {
    return hexCode;
  }

  let sanitizedHex = hexCode.replace("#", "");

  if (sanitizedHex.length === 3) {
    sanitizedHex = normalizeHex(sanitizedHex);
  }

  const num = parseInt(sanitizedHex, 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) + amt;
  const G = ((num >> 8) & 0x00ff) + amt;
  const B = (num & 0x0000ff) + amt;

  const newColor = (
    0x1000000 +
    (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
    (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
    (B < 255 ? (B < 1 ? 0 : B) : 255)
  )
    .toString(16)
    .slice(1);

  return `#${newColor}`;
};

export default generateHexShade;
